
import React, { useContext, useEffect, useState } from "react";
import { Form,FormGroup,Input,Container } from "semantic-ui-react";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { observer } from "mobx-react-lite";
import oneOrderStore from "../../../../app/stores/oneOrderStore";
import Axios, { AxiosResponse } from 'axios'

import config from '../../../../app/api/apiconfig';

const baseURL = config.app.baseUrl
const getaccountbaseUrl = config.app.getaccountbaseUrl
const tokenUrl = config.app.tokenUrl
const integtokenUrl = config.app.integtokenUrl
let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!)

interface IProps {}




const AppointmentGrid: React.FC<IProps> = () => {
  const workorderStore = useContext(oneOrderStore);
  const { selectedWorkOrderAppointment: Curapps } = workorderStore;
  const [apps, setAppList] = useState([{}]);
  const { selectedWorkOrder: workorder } = workorderStore;
  const [accountdata,setaccountData] = useState();

  async function gettoken(){
    //if token already exists.
    var token:string
    var tk = await Axios({
        method:"post",
        url:tokenUrl,
    }).then((response) => {
      (token = response.data)
      var tokebe:string = token.substr(16, token.length-4)
      var tokenonly:string = tokebe.slice(0, -1)
      return tokenonly
    }
    ) 
  
    sessionStorage.setItem('token', tk)
    }

    //ADD220614 - for the second method to get dyna token 
    function getintegtoken(){
      let validToken = ""
      console.log ("getintegtokenUrl:", integtokenUrl)
        Axios.get(integtokenUrl).then(response => {
            if(response.status === 200){
              var responsedata = response.data;
              if (responsedata != null && responsedata.length > 9) {
                validToken = responsedata
                sessionStorage.setItem('token', responsedata)
              }
            }
        });
      }

    //ADD220614 - for the retrieve of account site-consideration thru dynamic
  function getAccountData(addressfullname){
    try
    {
      let validToken = ""
      if (sessionStorage.getItem("token")){
        validToken = sessionStorage.getItem("token")
        //console.log ("sessionToken:", sessionStorage.getItem("token"))
      } else{
        getintegtoken()
        validToken = sessionStorage.getItem("token")
      }      

      let addrsplit = addressfullname.split(/\r\n/);
      let thisfilter = ""
      console.log(addrsplit)
      if (addrsplit.length > 1){
        thisfilter = "$filter=startswith(name, '" + addrsplit[0] + "') and contains(name, '" + addrsplit[1] + "')"
      }
      else{
        thisfilter = "$filter=contains(name, '" + addrsplit[0] + "')"
      }
      let geturl = getaccountbaseUrl + "?" + thisfilter
      let config  = {
        headers: {
          'Authorization': 'Bearer ' + validToken
        }
      }
      console.log(geturl)
      Axios.get(geturl, config)
        .then(response => {
            if(response.status === 200){
              var getvalue = response.data.value[0].gilm_siteconsiderations;
              console.log('get1st',getvalue);
              if (getvalue == null || getvalue.length < 2){
                getvalue = " "
                setaccountData(getvalue)
              }
              else{
                setaccountData(getvalue)
              }
            }
        }).catch((error) =>{
          if (error.response && error.response.status === 401) {
              console.log('TokenError',error.response)
              getintegtoken()
              validToken = sessionStorage.getItem("token")
              config  = {
                headers: {
                  'Authorization': 'Bearer ' + validToken
                }
              }
              Axios.get(geturl, config).then(response => {
              if(response.status === 200){
                var getvalue = response.data.value[0].gilm_siteconsiderations;
                console.log('get2nd',getvalue);
                if (getvalue == null){
                  getvalue = " "
                  setaccountData(getvalue)
                }
                else{
                  setaccountData(getvalue)
                }
              }
              })

          }
        })
    }
    catch(ex){
        console.error("An error has occurred: " + ex)
    }
  }

  useEffect(() => {
    getAccountData(workorder.Address);
    if (workorder != null) {
      setAppList(Curapps);
    }
  }, [Curapps,workorder]);

  return (
    <Container>
      <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Input
                      value={accountdata}
                      readOnly 
                      label="Site Consideration"
                      size="mini"
                      placeholder="Site Consideration"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>
      </Form>
      <div
        className="ag-theme-material"
        style={{ height: "200px", width: "100%" }}
      >
        <AgGridReact
          enableColResize={true}
          enableSorting={true}
          colResizeDefault={true}
          columnDefs={SorCols}
          rowData={apps}
        />
      </div>
    </Container>
  );
};

const SorCols = [
  {
    headerName: "Status",
    field: "BookingStatus",
    width: 150
  },
  { headerName: "Resource Name", field: "ResourceName", width: 200 },
  { headerName: "Start Time", field: "StartTime",valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true, width: 200 },
  {
    headerName: "End Time",
    field: "EndTime",
    valueFormatter: dateFormatterNoDaylight,filter:true,suppressMenu:true,
    width: 200,

  }
];

function dateFormatter(params:any) {
  var date = new Date(params.value);
  return date.toLocaleString();
}

function dateFormatterNoDaylight(params:any) {
  if(params.value){
    var formatdate = (params.value).replace("T", " ").replace("Z", "");
    return formatdate.toString();
  }
  else{
    return (params.value);
  }
}


export default observer(AppointmentGrid);
